import React from 'react';
import DocumentDetailsPage from './OrderDetailsPage';

// Offer details have their own entry point so Offer-specific evolution can be
// routed independently from Orders while continuing to share common document
// utilities and callbacks.
export default function OfferDetailsPage(props) {
  return <DocumentDetailsPage {...props} />;
}
